import type { BlockRecord } from '../stores/types'

/**
 * Progressive block-duration escalation based on violation history in the
 * last 30 days:
 *
 * | Recent offenses                  | Block duration |
 * |----------------------------------|----------------|
 * | ≥ 3 month-length blocks          | 1 year         |
 * | ≥ 3 week-length blocks           | 30 days        |
 * | ≥ 3 day-length blocks            | 7 days         |
 * | ≥ 5 short blocks                 | 1 day          |
 * | otherwise                        | initialBlockMs |
 */
export const calculateBlockDuration = (
  history: BlockRecord['blockHistory'],
  initialBlockMs: number
): number => {
  const cutoff = Date.now() - 30 * 24 * 60 * 60_000
  const recent = history.filter(b => b.timestamp > cutoff)

  if (recent.length === 0) return initialBlockMs

  const tally = { initial: 0, day: 0, week: 0, month: 0 }

  for (const b of recent) {
    if (b.duration >= 30 * 24 * 60 * 60_000) tally.month++
    else if (b.duration >= 7 * 24 * 60 * 60_000) tally.week++
    else if (b.duration >= 24 * 60 * 60_000) tally.day++
    else tally.initial++
  }

  if (tally.month >= 3) return 365 * 24 * 60 * 60_000
  if (tally.week >= 3) return 30 * 24 * 60 * 60_000
  if (tally.day >= 3) return 7 * 24 * 60 * 60_000
  if (tally.initial >= 5) return 24 * 60 * 60_000
  return initialBlockMs
}
